// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
    // if(jQ('html').hasClass('js-drawer-open')) {
    //    jQ(suggestionElement).parent().css({
    //         'position': 'fixed',
    //     });
    //     jQ(suggestionElement).css({
    //         'overflow-y': 'scroll',
    //         'max-height': '500px'
    //     });
    // }
};